import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { email, instagramNotice, socialMedia } from '@config';
import { NoticeModal, Side } from '@components';
import { Icon } from '@components/icons';
import { trackEvent } from '@utils';

const StyledSocialList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;

  &:after {
    content: '';
    display: block;
    width: 1px;
    height: 90px;
    margin: 0 auto;
    background-color: var(--light-slate);
  }

  li {
    &:last-of-type {
      margin-bottom: 20px;
    }

    a,
    button {
      padding: 10px;
      background: transparent;
      border: 0;
      color: inherit;
      cursor: pointer;

      &:hover,
      &:focus {
        transform: translateY(-3px);
      }

      svg {
        width: 20px;
        height: 20px;
      }
    }
  }
`;

const Social = ({ isHome }) => {
  const [activeNotice, setActiveNotice] = useState(null);
  const noticeMap = {
    instagram: instagramNotice,
  };

  const closeNotice = () => setActiveNotice(null);

  return (
    <>
      <Side isHome={isHome} orientation="left">
        <StyledSocialList>
          {socialMedia &&
            socialMedia.map(({ url, name, notice }, i) => (
              <li key={i}>
                {notice && noticeMap[notice] ? (
                  <button
                    type="button"
                    aria-label={name}
                    onClick={() => {
                      trackEvent('social_click', {
                        network: name,
                        location: 'social',
                        action: 'notice',
                      });
                      setActiveNotice(noticeMap[notice]);
                    }}>
                    <Icon name={name} />
                  </button>
                ) : (
                  <a
                    href={url}
                    aria-label={name}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() =>
                      trackEvent('social_click', { network: name, location: 'social' })
                    }>
                    <Icon name={name} />
                  </a>
                )}
              </li>
            ))}
        </StyledSocialList>
      </Side>

      <NoticeModal
        isOpen={Boolean(activeNotice)}
        onClose={closeNotice}
        title={activeNotice?.title || 'Notice'}
        message={activeNotice?.message || ''}
        actionLabel={activeNotice?.actionLabel || 'Send email'}
        actionHref={`mailto:${email}`}
        onActionClick={() => trackEvent('email_click', { location: 'instagram_notice' })}
      />
    </>
  );
};

Social.propTypes = {
  isHome: PropTypes.bool,
};

export default Social;
